<template>
    <v-card-actions>
        <v-spacer />
        <v-btn
            @click="close"
            color="red darken-1"
            text
        >
            Close
        </v-btn>
    </v-card-actions>
</template>

<script>
    export default {
        name: "ViewDialogActions",

        props: {
            close: {
                default: undefined,
                type: Function
            }
        }
    }
</script>

<style scoped>

</style>
